import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitTrialLead = (data) => axios.post(`${API}/leads/trial`, data);
export const submitDemoLead = (data) => axios.post(`${API}/leads/demo`, data);
